
// 公共接口
import axios from '@/utils/request';

let initInfoCache = null;
let initInfoPending = null;

export const $getEntInitInfo = (data, options) => {
  if (initInfoCache) return Promise.resolve(initInfoCache);
  if (!initInfoPending) {
    initInfoPending = axios.post('/ent_plt_ent_manager/GetEntInitInfo', data, options)
      .then(res => {
        initInfoCache = res;
        return res;
      })
      .finally(() => {
        initInfoPending = null;
      });
  }
  return initInfoPending;
};

export function clearEntInitInfoCache() {
  initInfoCache = null;
  initInfoPending = null;
}


export const $getActivityList = data =>
  axios.post('/ent_plt_ent_manager/GetActivityList', data);

export const $sendSms = data =>
  axios.post('/ent_plt_ent_manager/SendSms', data);
export const $getOcrData = data =>
  axios.post('/ent_plt_ent_manager/GetOcrData', data);

// 企业入驻
export const $initEntInfo = data =>
  axios.post('/ent_plt_ent_manager/InitEntInfo', data);
// 拉取企业分类
export const $getEntIndustryType = (data, options) =>
  axios.post('/ent_plt_ent_manager/GetEntIndustryType', data, options);

export const $getEntInfo = data =>
  axios.post('/ent_plt_ent_manager/GetEntInfo', data);

// 查询当前登录用户基本信息(姓名/手机号)，用于企业入驻页联系人信息自动补全
export const $getLoginUserInfo = (data, options) =>
  axios.post('/ent_plt_ent_manager/GetLoginUserInfo', data, options);

export const $getActivityInfo = data =>
  axios.post('/ent_plt_ent_manager/GetActivityInfo', data);


// 导出捐赠明细
export const $exportQueryData = data =>
  axios.post('/data_manager/AsyncExportQueryData', data);


// 获取二维码
export const $getQrCode = data =>
  axios.post('/ent_plt_ent_manager/GetQrCode', data);


// 用户协议
export const $getProtocol = data =>
  axios.post('/ent_plt_ent_manager/GetProtocol', data);

// 导出电子凭证
export const $exportDonateReceipts = data =>
  axios.post('/ent_plt_ent_manager/GetDonateReceipts', data);

// 拉取有筹款的收款商户号列表
export const $getMerchantList = data =>
  axios.post('/ent_plt_ent_manager/GetMerchantList', data);

// 查询数据导出任务列表
export const $getTaskList = data =>
  axios.post('/ent_plt_ent_manager/GetTaskList', data);

// 私有桶链接换取临时授权链接
export const $getPreSignedUrl = data =>
  axios.post('/ent_plt_ent_manager/GetPreSignedUrl', data);